export default "__VITE_ASSET__DMeyiIO9__"